var map = {
	"./accounting/claim-payout.js": "1250",
	"./accounting/company-deposit.js": "2ae8",
	"./accounting/dealer-withdrawal.js": "fe22",
	"./accounting/default-commission.js": "a775",
	"./accounting/payout.js": "d4e2",
	"./accounting/supper-deposit.js": "de97",
	"./administrator/company.js": "f3f8",
	"./administrator/content-management.js": "daec",
	"./administrator/dealer-profile.js": "7296",
	"./administrator/draw-setting.js": "edf9",
	"./administrator/front-cover.js": "d6a3",
	"./administrator/game-confirm-result.js": "04f6",
	"./administrator/game-prefix.js": "7761",
	"./administrator/game-set-result.js": "4c11",
	"./administrator/game-set.js": "a3fb",
	"./administrator/game-setting.js": "a07b",
	"./administrator/news.js": "8ee8",
	"./administrator/notification-template.js": "f075",
	"./dashboard/record.js": "1979",
	"./front/contact-us.js": "5c1e",
	"./front/content-management.js": "c82a",
	"./front/jackpot-result.js": "f61d",
	"./front/jackpot-section.js": "ee05",
	"./game/game-betting.js": "58d6",
	"./index.js": "2a74",
	"./report/ar-list.js": "c79a",
	"./report/claimed.js": "2da4",
	"./report/customer-profile.js": "0b8a",
	"./report/dealer-balance.js": "1ebd",
	"./report/dealer-payout.js": "dcc4",
	"./report/dealer-transaction.js": "2384",
	"./report/liability.js": "1066",
	"./report/unclaimed.js": "8deb",
	"./report/winning.js": "bea6",
	"./security/role.js": "168c",
	"./security/user.js": "8e74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0308";